const apiKey = "6jednuedIR6cks10";

// const apiKey = "DPyF4KAdI0F2cGT6";

export default apiKey;
